import * as React from 'react';
import Form from '../../FormIO/presentation/FormWithValidations';
import { connect } from 'react-redux';
import './assets/DataTranscriberValidationForm.scss';
import * as ReactDOM from 'react-dom';
import _ from "lodash";
import _cloneDeep from "lodash/cloneDeep";
import _isEqual from "lodash/isEqual";

export interface IDataTranscriberValidationFormPropsFromState {
  serviceURL: string;
}

interface IDataTranscriberValidationOwnProps {
  formId: string;
  data?: any;
  readOnly?: boolean;
  injectToSidebar?: any;
  onChange?: (formData: any, isValid?: boolean) => void;
}

export interface IDataTranscriberValidationFormPropsFromActions { }

export type IDataTranscriberValidationFormProps = IDataTranscriberValidationFormPropsFromActions &
  IDataTranscriberValidationFormPropsFromState &
  IDataTranscriberValidationOwnProps;

export class DataTranscriberValidationForm extends React.Component<
  IDataTranscriberValidationFormProps,
  any
> {
  private form: any;

  state = {
    sidebarElement: null,
  };

  logData = async () => {
    if (this.form && this.form.getSubmission) {
      console.log(this.form.getSubmission());
    }
  };

  public getFormData = () => {
    return this.form && this.form.getSubmission ? this.form.getSubmission() : null;
  };

  private wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  flushPendingInputCommit = async () => {
    const active = document.activeElement as HTMLElement | null;
    if (active && typeof active.blur === 'function') {
      active.blur();
    }
    await this.wait(225);
  };

  getLatestFormData = async () => {
    await this.flushPendingInputCommit();
    return this.getFormData();
  };

  isFormValid = () => {
    return !!this.form && this.form.isValid ? this.form.isValid() : false;
  };

  isFormValidAfterFlush = async () => {
    await this.flushPendingInputCommit();
    return this.isFormValid();
  };

  getValidationErrorsAfterFlush = async () => {
    await this.flushPendingInputCommit();
    return this.form && this.form.getValidationErrors
      ? this.form.getValidationErrors(true)
      : [];
  };

  formLoaded = () => {
    let divToLoad = document.getElementById('divSidebarAppend');
    if (!divToLoad) {
      divToLoad = document.createElement('div');
      divToLoad.id = 'divSidebarAppend';
    }
    const sidebar = document.getElementsByClassName('sidebar--wrapper')[0];
    if (!sidebar || !divToLoad) {
      return;
    }
    sidebar.appendChild(divToLoad);

    if (this.state.sidebarElement !== divToLoad) {
      this.setState({ sidebarElement: divToLoad });
    }
  };

  onChange = (formData: any, valid?: boolean) => {
    if (this.props.onChange) {
      const isValid =
        typeof valid === 'boolean' ? valid : this.isFormValid();
      this.props.onChange(formData, isValid);
      //this.formLoaded();
    }
  };

  componentDidUpdate(prevProps: IDataTranscriberValidationOwnProps) {
    if (!this.state.sidebarElement) {
      this.formLoaded();
    }

    if (prevProps.data !== this.props.data && this.props.data && this.props.onChange) {
      this.onChange(this.props.data, this.isFormValid());
    }
  }

  onFormRender = () => {
    this.formLoaded();
    if (this.props.onChange && this.form && this.form.getSubmission) {
      setTimeout(() => {
        this.onChange(this.form.getSubmission(), this.isFormValid());
      }, 0);
    }
  };

  onFormBlur = () => {
    if (this.props.onChange && this.form && this.form.getSubmission) {
      setTimeout(() => {
        this.onChange(this.form.getSubmission(), this.isFormValid());
      }, 225);
    }
  };


  render() {
    return (
      <React.Fragment>
        <div id='formio' onBlurCapture={this.onFormBlur}>
          <div className='container DataTranscriberForm'>
            <Form
              formId={this.props.formId}
              ref={(form) => (this.form = form)}
              data={this.props.data}
              onRender={this.onFormRender}
              onChange={(f, isValid) => this.onChange(f, isValid)}
              readOnly={this.props.readOnly}
            />
          </div>
        </div>
        {this.state.sidebarElement &&
          ReactDOM.createPortal(
            this.props.injectToSidebar,
            this.state.sidebarElement
          )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    serviceURL: reduxState.Application.backendURL,
  };
};

const mapDispatchToProps = {};

export default connect<any, IDataTranscriberValidationFormPropsFromActions>(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(DataTranscriberValidationForm);
